export interface ContactUpdateGroupsRequestModel {
  groups: number[];
}

